import {
  MapPin, Phone, Store, Image as ImageIcon, Search,
  Star, Share2, Globe, FileText, HeartHandshake,
  ClipboardCheck, Sparkles, Rocket, ShieldCheck, Clock, Wallet, Users, Crown,
  RefreshCw, PenTool, CreditCard, UtensilsCrossed, Palette, Mail, Layout,
} from "lucide-react";

export const BRAND = {
  name: "Impulsion Locale",
  slogan: "Plus de visibilité, plus de clients, plus simplement.",
  logo: "/logo.png",
};

export const CONTACT = {
  phone: "06.31.16.27.83",
  phoneRaw: "0631162783",
  whatsapp: "33631162783",
  email: "impulsionlocalesud@gmail.com",
  zones: ["Barbentane", "Rognonas", "Châteaurenard", "Avignon"],
  zoneText: "Barbentane, Rognonas, Châteaurenard, Avignon et environs",
};

export const IMAGES = {
  heroAbstract: "https://static.prod-images.emergentagent.com/jobs/e4f7f1de-b836-4e9f-a2cf-10805a832822/images/50ef228259ae1cafbbc6495cdaeb12e06716495d2cc8397bcdb1462737e92764.png",
  storefront: "https://static.prod-images.emergentagent.com/jobs/e4f7f1de-b836-4e9f-a2cf-10805a832822/images/b5df73ebd7e178e16c758c72b3fd4840fff684c7ca3f907c6ef34e8b38e0733f.png",
  baker: "https://images.pexels.com/photos/36445365/pexels-photo-36445365.jpeg",
  grocery: "https://images.pexels.com/photos/8475204/pexels-photo-8475204.jpeg",
  cafe: "https://images.pexels.com/photos/1307698/pexels-photo-1307698.jpeg",
};

export const NAV_ITEMS = [
  { label: "Accueil", path: "/" },
  { label: "Diagnostic", path: "/diagnostic" },
  { label: "Offres", path: "/offres" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Avis", path: "/avis" },
  { label: "Contact", path: "/contact" },
];

export const BENEFITS = [
  { icon: MapPin, title: "Plus de visibilité locale", text: "On vous rend facile à trouver pour les clients de votre ville." },
  { icon: Phone, title: "Plus d'appels et de messages", text: "Une présence claire incite les clients à vous contacter." },
  { icon: Store, title: "Plus de visites en magasin", text: "Attirez les gens du quartier au bon moment." },
  { icon: Star, title: "Une image plus professionnelle", text: "Des informations à jour et des visuels soignés inspirent confiance." },
  { icon: Search, title: "Une présence en ligne crédible", text: "Vos clients vous trouvent et savent à quoi s'attendre." },
];

export const SERVICES = [
  { icon: Globe, title: "Création de sites internet", text: "Sites vitrines clairs et professionnels qui convertissent vos visiteurs en clients." },
  { icon: RefreshCw, title: "Refonte de sites", text: "On modernise votre site existant pour une image à jour et efficace." },
  { icon: PenTool, title: "Logos", text: "Un logo professionnel qui donne une identité forte à votre activité." },
  { icon: CreditCard, title: "Cartes de visite", text: "Des cartes soignées, prêtes à imprimer, qui marquent les esprits." },
  { icon: FileText, title: "Flyers", text: "Des flyers et dépliants percutants pour vos offres et événements." },
  { icon: UtensilsCrossed, title: "Menus", text: "Des menus modernes et lisibles qui mettent vos plats en valeur." },
  { icon: ImageIcon, title: "Affiches", text: "Des affiches attractives pour vos promotions et vos événements." },
  { icon: MapPin, title: "Google Business Profile", text: "Optimisation complète de votre fiche pour être trouvé localement." },
];

export const PACKS = [
  {
    id: "Starter",
    name: "Pack Starter",
    tagline: "Idéal pour une nouvelle entreprise",
    description: "Idéal pour une nouvelle entreprise qui veut démarrer avec une image professionnelle.",
    icon: Sparkles,
    highlight: false,
    price: 399,
    features: [
      "Logo professionnel",
      "Carte de visite",
      "Flyer",
      "Optimisation Google Business Profile",
    ],
  },
  {
    id: "Standard",
    name: "Pack Standard",
    tagline: "Le plus rentable pour la majorité des commerçants",
    description: "L'équilibre parfait entre image de marque et présence en ligne.",
    icon: Rocket,
    highlight: true,
    price: 799,
    features: [
      "Logo",
      "Charte graphique",
      "Carte de visite",
      "Flyer",
      "Site vitrine (1 à 3 pages)",
      "Optimisation Google Business Profile",
    ],
    note: "Économie d'environ 120 € par rapport aux prestations séparées.",
  },
  {
    id: "Pro",
    name: "Pack Pro",
    tagline: "Pour une présence professionnelle complète",
    description: "Pour une entreprise qui veut une présence professionnelle complète.",
    icon: Crown,
    highlight: false,
    price: 1499,
    features: [
      "Logo",
      "Charte graphique",
      "Carte de visite",
      "Flyer",
      "Menu ou catalogue (selon l'activité)",
      "Site vitrine complet (4 à 6 pages)",
      "Optimisation Google Business Profile",
      "Création de l'adresse e-mail professionnelle",
      "1 mois de maintenance offert",
    ],
  },
];

export const UNIT_SERVICES = [
  { name: "Logo professionnel", desc: "3 propositions + fichiers HD", price: "149 €", icon: PenTool },
  { name: "Charte graphique", desc: "Couleurs, typographies, règles d'utilisation", price: "99 €", icon: Palette },
  { name: "Carte de visite", desc: "Design recto/verso prêt à imprimer", price: "69 €", icon: CreditCard },
  { name: "Flyer / Dépliant", desc: "Format A5/A4", price: "99 €", icon: FileText },
  { name: "Affiche", desc: "Événement ou promotion", price: "119 €", icon: ImageIcon },
  { name: "Menu restaurant", desc: "Design moderne", price: "149 €", icon: UtensilsCrossed },
  { name: "Bannière réseaux sociaux", desc: "Facebook, LinkedIn, etc.", price: "59 €", icon: Layout },
  { name: "Publication Instagram / Facebook", desc: "Design d'un post", price: "25 € / post", icon: Share2 },
  { name: "Site vitrine 1 page", desc: "Landing page", price: "349 €", icon: Globe },
  { name: "Site vitrine complet", desc: "4 à 6 pages", price: "699 €", icon: Globe },
  { name: "Refonte de site", desc: "Modernisation complète", price: "À partir de 499 €", icon: RefreshCw },
  { name: "Optimisation Google Business Profile", desc: "Mise en place complète", price: "149 €", icon: MapPin },
  { name: "Création d'une adresse e-mail professionnelle", desc: "Configuration incluse", price: "49 €", icon: Mail },
];

export const PORTFOLIO = {
  disclaimer: "Trattoria Bellavita est un restaurant fictif, imaginé de toutes pièces pour illustrer notre savoir-faire : identité de marque, site web et supports imprimés.",
  project: {
    name: "Trattoria Bellavita",
    subtitle: "L'Italie dans chaque assiette.",
    type: "Restaurant italien — projet fictif de démonstration",
    description: "Un projet de marque complet, pensé de A à Z : logo, charte graphique, site vitrine, carte de visite et menu. Une identité chaleureuse, authentique et cohérente sur tous les supports.",
    tags: ["Logo", "Charte graphique", "Site vitrine", "Carte de visite", "Menu"],
    website: [
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/zuz0x7gz_S1.webp", label: "Site vitrine — Accueil" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/hfsn1t04_S2.webp", label: "Site vitrine — Nos services" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/wo175i81_S3.webp", label: "Site vitrine — Le menu" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/911f7gms_S8.webp", label: "Site vitrine — Nos pizzas" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/xulxoawb_S6.webp", label: "Site vitrine — Réservez votre table" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/w7htzufi_S5.webp", label: "Site vitrine — Réservation en ligne" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/q1kusab6_S4.webp", label: "Site vitrine — Informations pratiques" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/4j5n2bth_S7.webp", label: "Site vitrine — Formulaire de contact" },
    ],
    print: [
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/13b4ss9l_Carte-De-Visite.png", label: "Carte de visite (recto / verso)" },
      { url: "https://customer-assets-jai6qajn.emergentagent.net/job_visibilite-locale-1/artifacts/2kcub4jh_Menu.png", label: "Menu du restaurant" },
    ],
  },
};

export const PRESTATIONS_NOTE = "D'autres services peuvent être ajoutés sur demande, avec un tarif défini d'un commun accord selon les besoins du projet.";

export const STEPS = [
  { icon: ClipboardCheck, title: "Je fais le diagnostic gratuit", text: "Quelques questions simples sur votre commerce, en 2 minutes." },
  { icon: FileText, title: "Vous recevez une recommandation claire", text: "Un score, un potentiel d'amélioration et le pack le plus adapté." },
  { icon: Rocket, title: "On met en place la solution adaptée", text: "On agit ensemble, étape par étape, sans jargon." },
];

export const TESTIMONIALS = [
  { name: "Sophie M.", role: "Salon de coiffure", text: "Depuis que ma fiche Google est à jour, j'ai beaucoup plus d'appels pour des rendez-vous. C'est simple et efficace." },
  { name: "Karim B.", role: "Restaurant", text: "Les photos et les publications ont changé l'image de mon restaurant. On me dit souvent qu'on m'a trouvé en ligne." },
  { name: "Laure D.", role: "Institut de beauté", text: "Enfin quelqu'un qui parle clairement et qui s'occupe de tout. Je recommande à tous les commerçants." },
];

export const FAQ = [
  { q: "Combien de temps faut-il pour voir une différence ?", a: "Les premières améliorations (fiche Google, présence claire) se voient souvent en quelques jours. Pour des résultats durables, comptez quelques semaines de mise en place régulière." },
  { q: "Est-ce que vous travaillez avec des petits commerces ?", a: "Oui, c'est même notre spécialité. Nous accompagnons les commerçants, artisans et indépendants de proximité, avec des solutions simples et abordables." },
  { q: "Est-ce que le diagnostic est gratuit ?", a: "Oui, totalement gratuit et sans engagement. En quelques minutes, vous obtenez votre score de visibilité et une recommandation adaptée." },
  { q: "Est-ce que vous intervenez dans ma ville ?", a: "Nous intervenons à Barbentane, Rognonas, Châteaurenard, Avignon et dans les environs. Contactez-nous pour vérifier votre secteur." },
  { q: "Est-ce que je dois avoir un site web pour commencer ?", a: "Non, pas du tout. On peut commencer par votre fiche Google et vos réseaux. Un mini-site peut venir ensuite, selon vos besoins." },
];

export const TRUST = [
  { icon: MapPin, title: "Service local", text: "Un partenaire de votre région qui connaît votre marché." },
  { icon: HeartHandshake, title: "Accompagnement humain", text: "Un interlocuteur dédié, à votre écoute." },
  { icon: ShieldCheck, title: "Solution simple", text: "Pas de jargon, des actions claires et concrètes." },
  { icon: Clock, title: "Réponse rapide", text: "On vous recontacte vite après votre demande." },
  { icon: Wallet, title: "Adapté aux petits budgets", text: "Des offres pensées pour les petites activités." },
  { icon: Users, title: "Démarche concrète", text: "On agit sur ce qui apporte vraiment des clients." },
];

export const DIAGNOSTIC_QUESTIONS = [
  { id: "q1", label: "Une fiche Google Business Profile à jour", question: "Avez-vous une fiche Google Business Profile à jour ?" },
  { id: "q2", label: "Un site web", question: "Avez-vous un site web ?" },
  { id: "q3", label: "Une page Facebook active", question: "Avez-vous une page Facebook active ?" },
  { id: "q4", label: "Un compte Instagram actif", question: "Avez-vous un compte Instagram actif ?" },
  { id: "q5", label: "Des avis clients récents sur Google", question: "Avez-vous des avis clients récents sur Google ?" },
  { id: "q6", label: "Horaires, adresse et téléphone visibles partout", question: "Vos horaires, adresse et téléphone sont-ils clairement visibles partout ?" },
  { id: "q7", label: "Des photos récentes et de qualité", question: "Avez-vous des photos récentes et de qualité de votre commerce ?" },
  { id: "q8", label: "Des publications de contenu régulières", question: "Publiez-vous régulièrement du contenu ?" },
  { id: "q9", label: "Une bonne visibilité dans les recherches locales", question: "Votre commerce apparaît-il facilement quand un client cherche votre activité dans la ville ?" },
  { id: "q10", label: "Une vraie stratégie d'acquisition locale", question: "Avez-vous déjà mis en place une vraie stratégie pour attirer plus de clients locaux en ligne ?" },
];

export const ACTIVITES = [
  "Restaurant / Café",
  "Salon de coiffure / Esthétique",
  "Garage / Automobile",
  "Artisan (bâtiment, métiers)",
  "Commerce de proximité",
  "Boulangerie / Alimentation",
  "Indépendant / Profession libérale",
  "Autre",
];
